(function () {
    'use strict';

    angular
        .module('app')
        .directive('rfError', rfError);

    rfError.$inject = ['$window', 'requiredFieldsService', 'loginService'];

    function rfError($window, requiredFieldsService, loginService) {
        // Usage:
        //     <rfError></rfError>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/requiredfields/templates/error.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.service = requiredFieldsService;

            scope.service = requiredFieldsService;
            scope.service.showError = false;
        }
    }

})();